export enum EVariableIncomeWithdrawSteps {
  INVESTMENT,
  PREVIEW,
  CONCLUSION
}
